import * as React from 'react';
import { t } from '@moovly/i18n';
import { FileDrop } from '@moovly/ui';
import { getLogo } from '../../utils/logo';
import { SettingsPanel, useSettingUpdate } from '@moovly/moovly-settings';
import { getInputAcceptString, UploadOptions } from '@moovly/clients';

const LogoImgStyle = {
  maxHeight: 70,
  padding: 20,
  width: 'min-content',
};

const DashBoardSettings: React.FC = () => {
  const { value: logo, onUpdate } = useSettingUpdate<string>('dashboard_customisation.logo');
  const handleUploadLogo = React.useCallback(
    async (file: File) => {
      if (!!file) {
        const logo = await getLogo(file);
        if (['sprite', 'svg'].includes(logo.type)) {
          // @ts-ignore
          const { path } = logo.assets[0];
          onUpdate(path);
        }
      }
    },
    [onUpdate]
  );

  return (
    <SettingsPanel title={t('settings.dashboard.logo')}>
      <div className="d-flex align-items-center justify-content-evenly">
        {logo && <img style={LogoImgStyle} alt="Uploaded" src={logo} className="mb-2" />}
        <FileDrop
          value={null}
          label={t('settings.logo.upload')}
          onChange={handleUploadLogo}
          accept={getInputAcceptString(UploadOptions.IMAGE)}
        />
      </div>
    </SettingsPanel>
  );
};
export default DashBoardSettings;
